import { AgentAccountWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentAccountApi = new AgentAccountWebService.AccountWebServiceApi(config);

export default agentAccountApi;
